import { Link } from "react-router-dom";
import { MapPin, Clock, Shield, CheckCircle, Lock, FileCheck, Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="footer" data-testid="site-footer">

      {/* ===== MAIN FOOTER COLUMNS ===== */}
      <div className="footer-main">

        {/* Column 1 — Brand & Contact */}
        <div className="footer-col">
          <h3 className="footer-brand">YourSolicitor.co.uk</h3>
          <p className="footer-tagline">YourSolicitor.co.uk is a trading name of Blue Lion Law Limited</p>
          <p className="footer-contact-heading">Contact Us</p>
          <ul className="footer-contact-list">
            <li>
              <Mail size={14} />
              <a href="mailto:contactus@bluelionclaims.co.uk">contactus@bluelionclaims.co.uk</a>
            </li>
            <li>
              <Phone size={14} />
              <a href="tel:02081530033">0208 153 0033</a>
            </li>
            <li>
              <MapPin size={14} />
              <span>The Centro Buildings,<br />20–23 Mandela Street,<br />London, NW1 0DU</span>
            </li>
            <li>
              <Clock size={14} />
              <span>Mon–Fri 9:00am – 6:00pm</span>
            </li>
          </ul>
        </div>

        {/* Column 2 — Quick Links */}
        <div className="footer-col">
          <h3 className="footer-col-heading">Quick Links</h3>
          <ul className="footer-nav-list">
            <li><a href="/">Home</a></li>
          </ul>
        </div>

        {/* Column 3 — Legal */}
        <div className="footer-col">
          <h3 className="footer-col-heading">Legal</h3>
          <ul className="footer-nav-list">
            <li><Link to="/privacy-policy" data-testid="privacy-policy-link">Privacy Policy</Link></li>
            <li><Link to="/terms-of-engagement" data-testid="terms-link">Terms of Engagement</Link></li>
            <li><Link to="/cookie-policy" data-testid="cookie-policy-link">Cookie Policy</Link></li>
            <li><Link to="/complaints-procedure" data-testid="complaints-link">Complaints Procedure</Link></li>
          </ul>
        </div>

        {/* Column 4 — Trust & Security */}
        <div className="footer-col">
          <h3 className="footer-col-heading">Trust &amp; Security</h3>
          <div className="footer-trust-grid">
            <div className="footer-trust-badge">
              <Shield size={22} />
              <span>SRA Regulated</span>
            </div>
            <div className="footer-trust-badge">
              <CheckCircle size={22} />
              <span>No Win, No Fee**</span>
            </div>
            <div className="footer-trust-badge">
              <Lock size={22} />
              <span>256-bit Secure</span>
            </div>
            <div className="footer-trust-badge">
              <FileCheck size={22} />
              <span>GDPR Compliant</span>
            </div>
          </div>
          <div className="footer-sra-card" data-testid="sra-badge">
            <div className="sra-logo">
              <div className="sra-logo-icon">
                <svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 50 L30 10 L50 50" stroke="white" strokeWidth="5" strokeLinejoin="round" fill="none"/>
                  <path d="M18 50 L42 50" stroke="white" strokeWidth="5" strokeLinecap="round"/>
                  <polyline points="38,28 50,16 50,28" stroke="white" strokeWidth="4" strokeLinejoin="round" fill="none"/>
                </svg>
              </div>
              <div className="sra-logo-text">
                <strong>SOLICITORS<br/>REGULATION<br/>AUTHORITY</strong>
                <span>&rsaquo; CHECK THIS FIRM</span>
              </div>
            </div>
            <div className="sra-number">SRA Number: 815166</div>
          </div>
        </div>

      </div>

      {/* ===== FOOTER BOTTOM — Legal disclaimers ===== */}
      <div className="footer-bottom">
        <p>*Using our specialist AI-powered solution, we identify an average of 2.5 agreements per client. This means our clients could achieve an average settlement of around &pound;2,075, on the basis of the FCA&rsquo;s estimated redress, per agreement, being around &pound;830. These aren&rsquo;t guaranteed amounts and all claims are subject to eligibility. On the basis of the FCA&rsquo;s estimated redress, per agreement, being around &pound;830.</p>
        <p>**No Win No Fee means you only pay our fees if your claim is successful and you abide by the terms of our agreement. Our fee for a successful claim that is settled without litigation is up to 36% inclusive of VAT. If your claim is settled through litigation, the maximum deduction is capped at 48% inclusive of VAT. Your claim would only be litigated if we believe you will achieve a better outcome. You can cancel without charge within 14 days of instructing us. For cancellations after 14 days, we can charge for our reasonable costs.</p>
        <p>The Financial Conduct Authority (FCA) has introduced a free to use motor finance Consumer Redress Scheme. It has indicated that redress may be on average around &pound;830 per agreement. The total estimated amount to be paid to consumers is &pound;7.5b.</p>
        <p>You can claim at no cost directly to the lender and then to the Financial Ombudsman Service, without using the services of a law firm or claims management company.</p>
        <p>This website uses cookies to improve your experience and for advertising purposes. By continuing to use this site, you consent to our use of cookies. See our <Link to="/cookie-policy">Cookie Policy</Link> for details.</p>
        <p>Details of any finance agreements we find from our checks and investigations will be provided after we have been instructed and we will pursue any claims we identify that have merit.</p>
        <p>YourSolicitor is a trading name of Blue Lion Law Limited, authorised and regulated by the Solicitors Regulation Authority (SRA Number: 815166). Company registered in England and Wales (No. 12276560). Registered office: The Centro Buildings, 20-23 Mandela Street, London, NW1 0DU.</p>
        <p className="footer-copyright">&copy; 2026 YourSolicitor.co.uk. All Rights Reserved.</p>
      </div>

    </footer>
  );
}
